import {grammarNumbers} from '../Utils';

export default {
  campaignNameIsExported: (campaignName) => ({
    "ru": `Рассылка "${campaignName}" успешно экспортирована`,
    "kk": `"${campaignName}" жолданымы табысты экспортталды`,
    "en": `"${campaignName}" bulk SMS successfully exported`
  }),
  campaignIsSendToContacts: (campaignName, contactsCount) => ({
    "ru": `Рассылка "${campaignName}" успешно отправлена на ${contactsCount} ${grammarNumbers(contactsCount, ['абонента', 'абонентов', 'абонентов'])}`,
    "kk": `"${campaignName}" жолданымы ${contactsCount} абонентке табысты жіберілді`,
    "en": `"${campaignName}" bulk SMS sent successfully to ${contactsCount} ${contactsCount !== 1 ? 'contacts' : 'contact'}`
  }),
  campaignFoundInBlackListContacts: (contactsCount) => ({
    "ru": `найдено в черном списке: ${contactsCount} ${grammarNumbers(contactsCount, ['абонента', 'абонентов', 'абонентов'])}`,
    "kk": `қара тізімде бар ${contactsCount} абонент`,
    "en": `found in blacklist: ${contactsCount} ${contactsCount !== 1 ? 'contacts' : 'contact'}`
  }),
  contactsRemoved: (contactsCount) => ({
    "ru": `${grammarNumbers(contactsCount, ['удален', 'удалено', 'удалено'])} ${contactsCount} ${grammarNumbers(contactsCount, ['получатель', 'получателя', 'получателей'])}`,
    "kk": `${contactsCount} пайдаланушы жойылды`,
    "en": `${contactsCount} ${contactsCount !== 1 ? 'recipients' : 'recipient'} deleted`,
  }),
  campaignDraftNameIsSaved: (name) => ({
    "ru": `Черновик рассылки ${name} успешно сохранен`,
    "kk": `${name} жолданымының жобасы табысты сақталды`,
    "en": `Draft ${name} bulk SMS saved successfully`
  }),
  campaignDraftNameIsDeleted: (name) => ({
    "ru": `Черновик рассылки ${name} успешно удален`,
    "kk": `${name} жолданымының жобасы табысты жойылды`,
    "en": `Draft ${name} bulk SMS deleted successfully`
  }),
  manyExcludedContactFromCampaign: (count) => ({
    "ru": count === 1 ? `исключен ${count} повторяющийся` : `исключено ${count} повторяющихся`,
    "kk": `${count} қайталанушы шығарылды`,
    "en": `${count} duplicates excluded`
  }),
  contactIsAdded: (count) => ({
    "ru": `${grammarNumbers(count, ['Добавлен', 'Добавлено', 'Добавлено'])} ${count} ${grammarNumbers(count, ['получатель', 'получателя', 'получателей'])}`,
    "kk": `${count} пайдаланушы қосылды`,
    "en": `${count} recipient added`
  }),
  allReceiversForCampaignName: (name, count) => ({
    "ru": `Все получатели рассылки${name ? ' ' + name : ''} (${count} ${grammarNumbers(count, ['номер', 'номера', 'номеров'])})`,
    "kk": `${name} жолданымын алушылардың барлығы (${count} нөмір)`,
    "en": `All recipients of the ${name} bulk SMS (${count} ${count !== 1 ? 'numbers' : 'number'})`
  }),
  contactsAreDeleted: (count) => ({
    "ru": `${count} ${grammarNumbers(count, ['контакт успешно удален', 'контакта успешно удалены', 'контактов успешно удалены'])}`,
    "kk": `${count} байланыс дерегі табысты жойылды`,
    "en": `${count} ${count !== 1 ? 'contact' : 'contacts'} successfully deleted`
  }),
  couldNotDeleteContact: (count) => ({
    "ru": `Не удалось удалить ${count !== 1 ? 'контакт' : 'контакты'}`,
    "kk": `Байланыс ${count !== 1 ? 'дерегін' : 'деректерін'} жою мүмкін болмады`,
    "en": `Failed to delete ${count !== 1 ? 'contact' : 'contacts'}.`
  }),
  contactsAreAddedToBlackList: (count) => ({
    "ru": `${count} ${grammarNumbers(count, ['контакт успешно добавлен', 'контакта успешно добавлены', 'контактов успешно добавлены'])} в черный список`,
    "kk": `${count} байланыс дерегі қара тізімге табысты енгізілді`,
    "en": `${count} ${count !== 1 ? 'contact' : 'contacts'} successfully blacklisted`
  }),
  contactsAreRemovedFromBlackList: (count) => ({
    "ru": `${count} ${grammarNumbers(count, ['контакт успешно удален', 'контакта успешно удалены', 'контактов успешно удалены'])} из черного списка`,
    "kk": `${count} байланыс дерегі қара тізімнен табысты жойылды`,
    "en": `${count} ${count !== 1 ? 'contact' : 'contacts'} successfully removed from the blacklist`
  }),
  contacts: (count) => ({
    "ru": `${grammarNumbers(count, ['контакт', 'контакта', 'контактов'])}`,
    "kk": `${count !== 1 ? 'байланыс дерегі' : 'байланыс деректері'}`,
    "en": `${count !== 1 ? 'contact' : 'contacts'}`
  }),
  contactsAreExported: (count) => ({
    "ru": `${count} ${grammarNumbers(count, ['контакт успешно экспортирован', 'контакта успешно экспортированы', 'контактов успешно экспортированы'])}`,
    "kk": `${count} байланыс дерегі табысты экспортталды`,
    "en": `${count} ${count !== 1 ? 'contact is' : 'contacts are'} successfully exported`
  }),
  contactsGroupAreExported: (count) => ({
    "ru": `${count} ${grammarNumbers(count, ['группа успешно экспортирована', 'группы успешно экспортированы', 'групп успешно экспортированы'])}`,
    "kk": `${count} байланыс деректерінің топтары табысты экспортталды`,
    "en": `${count} ${count !== 1 ? 'group is' : 'groups are'}  successfully exported`
  }),
  groupsAreDeleted: (count) => ({
    "ru": `${count} ${grammarNumbers(count, ['группа контактов успешно удалена', 'группы контактов успешно удалены', 'групп контактов успешно удалены'])}`,
    "kk": `${count} байланыс деректерінің топтары табысты жойылды`,
    "en": `${count} contact ${count !== 1 ? 'group' : 'groups'} deleted successfully`
  }),
  mobileOperatorsReportIsExported: (reportName) => ({
    "ru": `Отчет по мобильным операторам "${reportName}" успешно экспортирован`,
    "kk": `Мобильді операторлар бойынша "${reportName}" есеп табысты экспортталды`,
    "en": `"${reportName}" mobile operators report successfully exported`
  }),
};
